module.exports = __webpack_public_path__ + "static/img/shop.58431cb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/lookShop/shop.png
// module id = TD7B
// module chunks = 1